import { isWiseUiEnabled } from 'config/wiseUi';

import LegacyHomeSubelements from 'components/containers/HomeSubelements/HomeSubelements';
import WiseHomeSubelements from 'components/wise/WiseHomeSubelements/WiseHomeSubelements';

const HomeSubelements = isWiseUiEnabled() ? WiseHomeSubelements : LegacyHomeSubelements;

export default HomeSubelements;
